var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00000010",
    d: "M19.999,38.251C17.896,35.874,7.5,23.628,7.5,14C7.5,7.107,13.107,1.5,20,1.5S32.5,7.107,32.5,14 C32.5,23.58,22.102,35.866,19.999,38.251z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M20,2c6.617,0,12,5.383,12,12c0,8.932-9.29,20.349-12.001,23.491C17.286,34.358,8,22.977,8,14 C8,7.383,13.383,2,20,2 M20,1C12.82,1,7,6.82,7,14c0,10.981,13,25,13,25s13-14.074,13-25C33,6.82,27.18,1,20,1L20,1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f2faff",
    d: "M20,19.5c-3.032,0-5.5-2.467-5.5-5.5s2.468-5.5,5.5-5.5s5.5,2.467,5.5,5.5S23.032,19.5,20,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M20,9c2.761,0,5,2.239,5,5s-2.239,5-5,5s-5-2.239-5-5S17.239,9,20,9 M20,8c-3.308,0-6,2.692-6,6 s2.692,6,6,6s6-2.692,6-6S23.308,8,20,8L20,8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.4f440a89af91fdfe7c0fb56c58b7c9c1.svg";
export { ForwardRef as ReactComponent };